import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionsSection() {
  const solutions = [<span key="1" data-id="element-277">
      Pasarás de perseguir… a <strong data-id="element-278">ser buscada</strong>
    </span>, <span key="2" data-id="element-279">
      Él empezará a <strong data-id="element-280">invertir más en ti</strong> sin que tengas que
      pedírselo
    </span>, <span key="3" data-id="element-281">
      Sabrás <strong data-id="element-282">EXACTAMENTE qué decir</strong> en cada situación
    </span>, <span key="4" data-id="element-283">
      Sentirás <em data-id="element-284">seguridad, control y atracción</em> en cada conversación
    </span>, <span key="5" data-id="element-285">
      Harás que <strong data-id="element-286">piense en ti</strong> incluso cuando no le escribas
    </span>];
  return <section className="py-12 md:py-16 bg-dark" data-id="element-287">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-289">
          <h2 className="text-3xl xl:text-4xl font-bold text-white mb-4" data-id="element-290">
            Lo Que Va a Cambiar Para Ti
          </h2>
          <div className="w-24 h-1 bg-green-500 mx-auto rounded-full" data-id="element-291"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-292">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start p-5 bg-green-500/5 rounded-xl border border-green-500/20 transition-colors" data-id="element-293">
              <div className="flex-shrink-0 mt-1" data-id="element-294">
                <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center shadow-sm" data-id="element-295">
                  <CheckIcon className="w-5 h-5 text-white" strokeWidth={3} data-id="element-296" />
                </div>
              </div>
              <p className="ml-4 text-xl font-semibold text-gray-100" data-id="element-297">
                {solution}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}